// Store for user-reported BOZP incidents (persisted in localStorage when no backend).
const STORAGE_KEY = 'fm-incidentStore';

const loadStored = () => {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

let extraIncidents = loadStored();

const save = () => {
  try {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(extraIncidents));
    }
  } catch {}
};

export const getIncidents = () => [...extraIncidents];

export const addIncident = (incident) => {
  const withId = { ...incident, id: `incident-${Date.now()}` };
  extraIncidents.push(withId);
  save();
  return withId;
};

export const getMergedIncidents = (baseIncidents) => {
  return [...(baseIncidents || []), ...extraIncidents];
};
